import React from 'react';
import loadable from '@loadable/component';
import keywordListingPageQuery from './query.graphql';

const KeywordListingComponent = loadable(() =>
  import(/* webpackChunkName: "keyword-listing" */ './keyword-listing')
);

const KeywordListingPage = ({ data }) => (
  <KeywordListingComponent popularSearchTerms={data.popularSearchTerms} />
);

KeywordListingPage.graphQL = keywordListingPageQuery;

KeywordListingPage.variables = ({ id, limit, random }) => ({
  ids: id.split(','),
  limit: typeof limit === 'string' ? limit.replace(/[^\d]/g, '') : 3000,
  includeRandom:
    typeof random === 'string'
      ? ['1', 'true', 'yes'].includes(random.toLocaleLowerCase())
      : false,
});

export default KeywordListingPage;
